/* src/app/views/template/components/templates/digital/digital-template-collections/digital-template-collection-list/digital-template-collections-list.component.scss */
/*# sourceMappingURL=digital-template-collections-list.component.css.map */
